/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */
import { createForm } from '@amzn/base-ui/dist/helpers/form';

const colorOptions = [
  { text: 'Blue', value: 'blue' },
  { text: 'Green', value: 'green' },
  { text: 'Red', value: 'red' },
  { text: 'Orange', value: 'orange' },
  { text: 'Yellow', value: 'yellow' },
  { text: 'Grey', value: 'grey' },
];

const typeOptions = [
  { text: '*NEW*', value: '*NEW*' },
  { text: '*NOTICE*', value: '*NOTICE*' },
  { text: '*UPDATE*', value: '*UPDATE*' },
  { text: '*IMPORTANT*', value: '*IMPORTANT*' },
];

function getAnnouncementForm(announcement) {
  const fields = {
    type: {
      label: 'Type',
      placeholder: 'Select or enter a type label (e.g. *NEW*, *NOTICE*)',
      extra: {
        explain: 'A short label displayed before the announcement content.',
        options: typeOptions,
        allowAdditions: true,
        search: true,
        selection: true,
      },
      value: (announcement && announcement.type) || '',
      rules: 'required|string|min:1|max:50',
    },
    content: {
      label: 'Content',
      placeholder: 'Announcement body text, up to 2000 characters.',
      value: (announcement && announcement.content) || '',
      rules: 'required|string|min:1|max:2000',
    },
    color: {
      label: 'Colour',
      placeholder: 'Select a display colour',
      extra: {
        explain: 'The colour used to highlight this announcement on the dashboard.',
        options: colorOptions,
        selection: true,
      },
      value: (announcement && announcement.color) || '',
      rules: 'required',
    },
    status: {
      label: 'Active',
      extra: {
        yesLabel: 'Active',
        noLabel: 'Hidden',
      },
      value: announcement ? announcement.status === 'active' : true,
    },
    priority: {
      label: 'Priority',
      placeholder: 'Display priority (lower number = higher on page)',
      extra: {
        explain: 'Controls the display order. Lower numbers appear first.',
      },
      value: (announcement && String(announcement.priority)) || '0',
      rules: 'required|numeric|min:0',
    },
  };

  return createForm(fields);
}

// eslint-disable-next-line import/prefer-default-export
export { getAnnouncementForm, colorOptions, typeOptions };
